<template>
  <div class="iv-list-picture">
    <p class="iv-list-right-title"><span>{{ name }}</span></p>
    <div class="iv-list-right-cont">
      <div class="iv-list-li" v-for="item in menuList" :key="item.id" @click="todetail(item.id)">
        <img :src="getImgPath(item.blogPic)" :alt="item.title" @error="nofind">
        <p><span class="iv-m-r-8 iv-fc-45">[{{ item.publishTime }}]</span><span>{{ item.title }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>

// import {newsPrefixPath} from '@/config'

export default {
  props: ['name','id'],
  data() {
    return {
      menuList: [],
      total: 0,
      current: 1,
      currentPage: 1,
      categoryId: this.$route.query.categoryId || 'system_index',
      pageSize: 10
    }
  },
  created() {
    if (this.$route.query.categoryId) {
      this.initTabs()
    }
  },
  methods: {
    initTabs(categoryId) {
      if (categoryId) {
        this.currentPage = 1
        this.current = 1
        this.total = 0
      }
      this.categoryId = categoryId || this.categoryId
      let params = {
        columnId: this.categoryId,
        current: this.current,
        pageSize: this.pageSize,
        pageNum: this.currentPage
      }
      this.$ajax({
        url: 'api-qixuan/cms/front/getBlogList',
        method: 'get',
        data: params
      }).then(({data}) => {
        this.menuList = data.rows
        this.total = data.total
        this.$emit('onloaded')
      })
    },
    changePage(page) {
      this.current = page
      this.initTabs()
    },
    changePageSize(page) {
      this.pageSize = page
      this.initTabs()
    },
    getImgPath(id) {
      return require('@/assets/images/news/default-pic.png')
    },
    todetail(id) {
      const {href} = this.$router.resolve({
        name: 'newsDetail',
        query: {
          infoId: id
        }
      })
      window.open(href, '_blank')
    },
    nofind() {
      var img = event.srcElement
      img.src = require('@/assets/images/news/default-pic.png')
      img.onerror = null
    }
  }
}
</script>

<style lang="scss" scoped>
.iv-list-li {
  cursor: pointer;
}

.iv-list-picture {
  height: 100%;
}

.iv-list-right-title {
  height: 57px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 57px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  margin-bottom: 9px;

  span {
    display: inline-block;
    height: 57px;
    line-height: 57px;
    border-bottom: 2px solid #2373C8;
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
  }
}

.iv-list-right-cont {
  // overflow: auto;
  // height: 400px;
  div {
    display: inline-block;
    margin-right: 47px;
    width: 261px;
    margin-top: 25px;

    img {
      width: 261px;
      height: 196px;
    }

    p {
      width: 261px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.64);
      height: 48px;
      line-height: 24px;
      // font-weight: bold;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }

  }

  div:nth-of-type(3n) {
    margin-right: 0px;
  }

}
</style>